import React from "react";
import { withRouter, useLocation } from "react-router-dom";
import { getItem, removeItem, setItem } from "./SecureStorage";
import { useDispatch } from "react-redux";
import { authSuccess } from "./reducers/auth-reducers";

const SafEarthNavigator = ({ token, path }) => {
  const location = useLocation();
  const query = new URLSearchParams(location?.search);
  const isNew = query.get("is_new");
  const email = query.get("email");
  const projectId = query.get("projectId");
  const requestFinance = query.get("requestFinance");
  const createNewProposal = query.get("createNewProposal");
  const auctionToken = query.get("auctionToken");
  const redirectFrom = query.get("redirectFrom");
  const firstLogin = query.get("first_login");
  const department = query.get("department");
  const isConsumer = query.get("is_consumer");
  const companyName = query.get("company_name");
  const dispatch = useDispatch();

  setItem("userData", { authToken: token, username: email, department,companyName });
  dispatch(authSuccess({ authToken: token, username: email, department ,companyName}));

  setItem("redirectFrom", redirectFrom);
  setItem("is_new", isNew);
  setItem("email", email);
  setItem("auctionToken", auctionToken);

  if (projectId) {
    setItem("projectId", projectId);
  } else {
    removeItem("projectId");
  }

  if (requestFinance) {
    setItem("requestFinance", true);
  } else {
    removeItem("requestFinance");
  }

  if (createNewProposal) {
    setItem("createNewProposal", true);
  } else {
    removeItem("createNewProposal");
  }

  if (firstLogin) {
    setItem("firstLogin", true);
  }

  if (isConsumer) {
    const userData = JSON.parse(getItem("userData"));
    setItem("userData", {
      ...userData,
      department: "Customer",
      isConsumer: true,
      companyName
    });
    dispatch(
      authSuccess({
        ...userData,
        department: "Customer",
        isConsumer: true,
        companyName
      })
    );
  }

  return window.location.replace("/" + path);
};

export default withRouter(SafEarthNavigator);
